import moment from 'moment-timezone'
import { ContactCustomField } from "../models/contact";
import store from '@/store'
import {  getCountryDateFormat } from '../models';

export class CustomsFieldFormatter{

  private originalData : ContactCustomField[] = [];
  private fsFormatData : ContactCustomField[];


  private constructor(){}

  public static getFormatter(contactCSItems: ContactCustomField[]): CustomsFieldFormatter { // factory method
     const formatter = new CustomsFieldFormatter();
     formatter.originalData = contactCSItems && contactCSItems.length ? [...contactCSItems]: [];
     return formatter;
  }

  public getFSFormatFields (forceupdate: boolean) : ContactCustomField[] {
    if (!this.fsFormatData || forceupdate) {
      this.fsFormatData = this.convertAllToFSFormat(this.originalData)
    }
    return this.fsFormatData;
  }

  public canShowSmartListColumn(id: string): boolean {
    if (this.originalData && this.originalData.length > 0 ) {
        return (this.originalData.findIndex((a) => a && a.id === id) > -1);
    }
    return false;
  }

  public showSmartListValue(id: string): any {
    if (this.originalData && this.originalData.length > 0 ) {
      const item = this.originalData.find((a) => a && a.id === id);
      if (!item) return null;
      if (item.field_value_date && typeof item.field_value_date === 'number' )  {
        return moment(item.field_value_date).utc().format(getCountryDateFormat('month date, year'));
      } else return `${item.field_value_number  || item.field_value_array || item.field_value_string || item.field_value  || ''}`;
    }
    return null;
  }

  public convertAllToFSFormat(contactCSItems: ContactCustomField[]): ContactCustomField[]{
    if (!contactCSItems) return [];
    if (contactCSItems.custom_fields) contactCSItems = contactCSItems.custom_fields; // just in case
    if (!contactCSItems.length) return [];

    let returnData = [];
    const expected = contactCSItems.filter(a=> Object.keys(a).includes('field_value'));
    if (expected && expected.length === contactCSItems.length) return expected;
    else returnData = [...expected]

    const unExpected = contactCSItems.filter(a=> !a.field_value);
    if (!unExpected || !unExpected.length || unExpected.length <= 0) return returnData;

    const locCustomFields = [...store.state.locationCustomFields.customFields];
    if (!locCustomFields || !locCustomFields.length) return contactCSItems;

    for( const locES of locCustomFields) {
      if(locES.dataType === 'TEXTBOX_LIST'){
        const optionIds = locES.picklistOptions ? locES.picklistOptions.map(a=> a.id) : [];
        const item = {id: locES.id, field_value: {}}
        const multiOptionItems = unExpected.filter(unexp => optionIds.includes(unexp.id))
        multiOptionItems.forEach(pickListOption => {
            item.field_value[pickListOption.id] =  pickListOption.field_value_string || pickListOption.field_value_number;
        });
        if(Object.keys(item.field_value).length > 0) returnData.push(item);
      } else {
          const contactHasIt = unExpected.find(a=> a.id === locES.id)
          if(contactHasIt) returnData.push(this.asFSItem(contactHasIt))
      }
    }
    return returnData;
  }

  private asFSItem(contactCS: ContactCustomField): ContactCustomField{
    if (!contactCS) return null;
    try  {
      if (contactCS.field_value_date) {
        const dt = moment(contactCS.field_value_date)
        return {id: contactCS.id, field_value: dt.format('YYYY-MM-DD') } as ContactCustomField;
      } else  {
        return {id: contactCS.id, field_value: contactCS.field_value_array || contactCS.field_value_number || contactCS.field_value_string} as ContactCustomField;
      }
    } catch{
      console.log({})
      return null;
    }
  }
}

export class CustomsFieldCorrector{

  private fsFormatData : ContactCustomField[];

  private constructor(){}

  public get FSFormatFields () : ContactCustomField[] {
    return this.fsFormatData;
  }

  public static getFormatter(contactCSItems: ContactCustomField[]): CustomsFieldCorrector { // factory method
     const formatter = new CustomsFieldCorrector();
     const originalData = contactCSItems && contactCSItems.length ? [...contactCSItems]: [];
     formatter.fsFormatData =  formatter.convertAllToFSFormat(originalData)
     return formatter;
  }

  private convertAllToFSFormat(contactCSItems: ContactCustomField[]): ContactCustomField[]{
    if (!contactCSItems) return [];
    if (contactCSItems.custom_fields) contactCSItems = contactCSItems.custom_fields; // just in case
    if (!contactCSItems.length) return [];

    let returnData = [];
    const expected = contactCSItems.filter(a=> Object.keys(a).includes('field_value'));
    if (expected && expected.length === contactCSItems.length) return expected;
    else returnData = [...expected]

    const unExpected = contactCSItems.filter(a=> !a.field_value);
    if (!unExpected || !unExpected.length || unExpected.length <= 0) return returnData;

    const locCustomFields = [...store.state.locationCustomFields.customFields];
    if (!locCustomFields || !locCustomFields.length) return contactCSItems;

    for( const locES of locCustomFields) {
      if(locES.dataType === 'TEXTBOX_LIST'){
        const optionIds = locES.picklistOptions ? locES.picklistOptions.map(a=> a.id) : [];
        const item = {id: locES.id, field_value: {}}
        const multiOptionItems = unExpected.filter(unexp => optionIds.includes(unexp.id))
        multiOptionItems.forEach(pickListOption => {
            item.field_value[pickListOption.id] =  pickListOption.field_value_string || pickListOption.field_value_number;
        });
        if(Object.keys(item.field_value).length > 0) returnData.push(item);
      } else {
          const contactHasIt = unExpected.find(a=> a.id === locES.id)
          if(contactHasIt) returnData.push(this.asFSItem(contactHasIt))
      }
    }
    return returnData;
  }

  private asFSItem(contactCS: ContactCustomField): ContactCustomField{
    if (!contactCS) return null;
    try  {
      if (contactCS.field_value_date) {
        const dt = moment(contactCS.field_value_date)
        return {id: contactCS.id, field_value: dt.format('YYYY-MM-DD') } as ContactCustomField;
      } else  {
        return {id: contactCS.id, field_value: contactCS.field_value_array || contactCS.field_value_number || contactCS.field_value_string} as ContactCustomField;
      }
    } catch{
      console.log({})
      return null;
    }
  }
}
